import { useCallback } from 'react';
import { Res, MailStub } from 'api/api.types';
import { useAxios } from '../axios';
import {
  GetMailAddressesParams,
  GetNotificationStubParams,
  SendNotificationParams,
} from './documentMails.types';

export const useGetNotificationStub = () => {
  const [{ data, loading }, axiosFetch] = useAxios<Res<MailStub>>({
    method: 'GET',
  });

  const getNotificationStub = useCallback(
    ({ jobEntryIds }: GetNotificationStubParams) => {
      const [firstId, ...rest] = jobEntryIds;
      return axiosFetch({
        url: `/job/entry/documentMails/notification/stub/${firstId}`,
        params: rest.length > 0 ? { jobEntryIds } : undefined,
        paramsSerializer: (params) =>
          (params.jobEntryIds as number[])
            .map((id) => `jobEntryIds=${id}`)
            .join('&'),
      });
    },
    [axiosFetch],
  );

  return {
    data: data?.result,
    loading,
    getNotificationStub,
  };
};

export const useGetMailAddresses = () => {
  const [{ data, loading }, axiosFetch] = useAxios<Res<string[]>>({
    method: 'GET',
  });

  const getMailAddresses = useCallback(
    ({ counterpartyIds }: GetMailAddressesParams) =>
      axiosFetch({
        url: '/counterparty/mailaddresses',
        params: {
          filterText: '',
          pageNumber: 1,
          resultSize: 100,
          withSystemUsers: true,
          counterpartyIds,
        },
        paramsSerializer: (params) =>
          [
            `filterText=${params.filterText ?? ''}`,
            `pageNumber=${params.pageNumber ?? 1}`,
            `resultSize=${params.resultSize ?? 100}`,
            `withSystemUsers=${params.withSystemUsers ?? true}`,
            ...(params.counterpartyIds as number[]).map(
              (id) => `counterpartyIds=${id}`,
            ),
          ].join('&'),
      }),
    [axiosFetch],
  );

  return {
    data: data?.result,
    loading,
    getMailAddresses,
  };
};

export const useSendNotification = () => {
  const [{ loading }, axiosFetch] = useAxios<Res<unknown>>({
    method: 'POST',
  });

  const sendNotification = useCallback(
    ({ jobId, payload }: SendNotificationParams) =>
      axiosFetch({
        url: `/job/entry/documentMails/${jobId}/notification`,
        data: payload,
      }),
    [axiosFetch],
  );

  return { loading, sendNotification };
};

export const useGetWaybill = () => {
  const [{ data, loading }, axiosFetch] = useAxios<Res<MailStub>>({
    method: 'GET',
  });

  const getWaybill = useCallback(
    ({ jobEntryIds }: GetNotificationStubParams) => {
      const [firstId, ...rest] = jobEntryIds;
      return axiosFetch({
        url: `/job/entry/documentMails/waybill/stub/${firstId}`,
        params: rest.length > 0 ? { jobEntryIds } : undefined,
        paramsSerializer: (params) =>
          (params.jobEntryIds as number[])
            .map((id) => `jobEntryIds=${id}`)
            .join('&'),
      });
    },
    [axiosFetch],
  );

  return { data: data?.result, loading, getWaybill };
};

export const useSendWaybill = () => {
  const [{ loading }, axiosFetch] = useAxios<Res<unknown>>({
    method: 'POST',
  });

  const sendWaybill = useCallback(
    ({ jobId, payload }: SendNotificationParams) =>
      axiosFetch({
        url: `/job/entry/documentMails/${jobId}/waybill`,
        data: payload,
      }),
    [axiosFetch],
  );

  return { loading, sendWaybill };
};
